"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dateFns = require("date-fns");
var _core = require("core.ui-module_site-components");
var _RunasUserSelectionStepResponse = _interopRequireDefault(require("../api/auth/RunasUserSelectionStepResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ConsultantTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadData", () => {
      this.setState({
        isLoading: true
      });
      this.setState({
        consultant: this.props.consultants || [],
        isLoading: false
      });
    });
    _defineProperty(this, "handleConsultantSelected", e => {
      const {
        value
      } = e.target;
      this.setState({
        value
      });
      this.props.buttonTypeonChange({
        isbtnDisabled: false
      });
    });
    _defineProperty(this, "onSubmitForm", () => {
      // event.preventDefault();    
      this.setState({
        errorMessage: '',
        isLoading: true
      });
      const step = new _RunasUserSelectionStepResponse.default();
      step.uid = this.state.value;
      this.props.listener(this, step);
    });
    _defineProperty(this, "handleSearch", event => {
      const {
        consultant
      } = this.state;
      const typedVal = event.target.value;
      const finalData = consultant.map(item => ({
        ...item,
        fullName: `${item.firstName} ${item.lastName}` || ''
      }));
      if (typedVal) {
        const FilterData = finalData.filter(data => data.fullName && data.fullName.toLowerCase().includes(typedVal.toLowerCase()) || data.webUserId && data.webUserId.toLowerCase().includes(typedVal.toLowerCase()) || data.organizationName && data.organizationName.toLowerCase().includes(typedVal.toLowerCase()) || data.emailAddress && data.emailAddress.toLowerCase().includes(typedVal.toLowerCase()));
        this.setState({
          consultantFilterData: FilterData,
          searchInputText: typedVal
        });
      } else {
        this.setState({
          searchInputText: ''
        });
      }
    });
    _defineProperty(this, "clearAllFunction", () => {
      this.setState({
        searchInputText: '',
        value: ''
      });
    });
    this.state = {
      value: '',
      isLoading: false,
      onSubmitLoading: false,
      searchInputText: '',
      consultant: [],
      consultantFilterData: []
    };
    this.selectedConsultant = '';
    this.selectedFundsCheckboxes = [];
    this.handleConsultantSelected = this.handleConsultantSelected.bind(this);
  }
  componentDidMount() {
    this.loadData();
  }
  render() {
    const {
      isLoading,
      consultant,
      value,
      onSubmitLoading,
      consultantFilterData,
      searchInputText
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, onSubmitLoading ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '100%',
        width: '100%',
        position: 'absolute',
        zIndex: '20'
      },
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Spinner, null)) : '', /*#__PURE__*/_react.default.createElement("div", {
      className: "columns"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "input",
      type: "search",
      onChange: this.handleSearch,
      placeholder: "Search consultant",
      style: {
        width: '25%'
      },
      value: searchInputText
    })), /*#__PURE__*/_react.default.createElement(_core.RcReactTable
    // eslint-disable-next-line no-nested-ternary
    , {
      data: isLoading ? [] : searchInputText === '' ? consultant : consultantFilterData,
      columns: [{
        Header: '',
        accessor: 'selected',
        sortable: false,
        width: '50',
        Cell: row => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
          className: "columns is-vcentered radio",
          style: {
            marginLeft: '0'
          }
        }, /*#__PURE__*/_react.default.createElement("input", {
          name: "selectConsultant",
          defaultChecked: value,
          onChange: this.handleConsultantSelected,
          value: row.original.webUserId,
          ref: this.setCheckboxRef,
          checked: value === row.original.webUserId,
          type: "radio",
          style: {
            border: 'black'
          }
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "spnRadio"
        }, '')))
      }, {
        Header: 'Unique Id',
        accessor: 'webUserId',
        width: '100%',
        Cell: row => /*#__PURE__*/_react.default.createElement("div", {
          className: ""
        }, row.value)
      }, {
        Header: 'Name',
        accessor: 'lastName',
        Cell: row => /*#__PURE__*/_react.default.createElement("div", null, row.original.firstName, " ", row.value),
        width: '100%'
      }, {
        Header: 'Status',
        accessor: 'status',
        Cell: row => row.value,
        width: '100%'
      }, {
        Header: 'Company',
        accessor: 'organizationName',
        Cell: row => row.value,
        width: '100%'
      }, {
        Header: 'Email',
        accessor: 'emailAddress',
        Cell: row => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, row.original.emailAddressOverride ? row.original.emailAddressOverride : row.value),
        width: '100%'
      }, {
        Header: 'User Id',
        accessor: 'selfSelectedId',
        width: '100%',
        Cell: row => /*#__PURE__*/_react.default.createElement("div", {
          className: ""
        }, row.value)
      }, {
        Header: 'Last Login',
        accessor: 'lastLoginDate',
        Cell: row => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, row.value ? (0, _dateFns.format)((0, _dateFns.parseISO)(row.value), 'M/d/yyyy h:mm:ss a') : ''),
        width: '100%'
      }],
      minRows: 0,
      defaultSorted: [{
        id: 'lastName',
        desc: false
      }],
      noRowsText: "No consultant found",
      loading: isLoading,
      tableIdentifer: "ConsultantTable",
      showPagination: true,
      pageSize: 8
    }), /*#__PURE__*/_react.default.createElement(_core.RcReactTablePagination, {
      tableIdentifer: "ConsultantTable"
    }));
  }
}
ConsultantTable.propTypes = {
  buttonTypeonChange: _propTypes.default.func,
  consultants: _propTypes.default.any,
  listener: _propTypes.default.func.isRequired
};
var _default = exports.default = ConsultantTable;
//# sourceMappingURL=ConsultantTable.js.map